import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  NumberInput,
  NumberInputField,
  FormControl,
  Flex,
  Box,
  ModalFooter,
  FormLabel
} from '@chakra-ui/react'
import { FC } from 'react'
import { BiSliderAlt } from 'react-icons/bi'
import { FiEdit2 } from 'react-icons/fi'
import { IoIosAddCircle } from 'react-icons/io'

import useParametrizationMinimumBilling from '@hook/parametrization/use-mininum-billing'

import Filter from '@component/Shared/Filter'

const ParametrizationSimilarProductCreate: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    filterEdit,
    loaddingEdit,
    paramsEdit,
    selected,
    handleUpdateEditParams,
    createData,
    updateMinimumBilling
  } = useParametrizationMinimumBilling()

  return (
    <>
      {selected !== 0 ? (
        <Button
          fontSize={14}
          size="sm"
          marginLeft={2}
          leftIcon={<FiEdit2 />}
          colorScheme="green"
          variant="outline"
          onClick={onOpen}
        >
          Editar
        </Button>
      ) : (
        <Button
          fontSize={14}
          size="sm"
          leftIcon={<IoIosAddCircle />}
          colorScheme="blue"
          variant="outline"
          onClick={onOpen}
        >
          Adicionar
        </Button>
      )}
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader bg="white">
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {selected !== 0
                  ? 'Editar Faturamento Minimo'
                  : 'Criar Faturamento Minimo'}
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody bg="white" pt={0} py={4}>
            <FormControl isRequired>
              <Filter
                label="Empresa"
                options={filterEdit.companies}
                value={paramsEdit.empresa}
                onChange={value =>
                  handleUpdateEditParams({ name: 'empresa', value: value })
                }
                isLoading={loaddingEdit}
              />
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <Filter
                label="Fornecedor"
                options={filterEdit.suppliers}
                value={paramsEdit.fornecedor}
                onChange={value =>
                  handleUpdateEditParams({ name: 'fornecedor', value: value })
                }
                isLoading={loaddingEdit}
              />
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>Faturamento Minimo R$</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.faturamentoMinimo}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'faturamentoMinimo',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
          </ModalBody>
          <ModalFooter bg="white">
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                if (selected !== 0) {
                  updateMinimumBilling()
                  onClose()
                } else {
                  createData()
                  onClose()
                }
              }}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ParametrizationSimilarProductCreate
